/**
 * Normalización de las opciones de los desplegables de Móviles a `{value, label}`.
 *
 * EL BUG QUE ORIGINÓ ESTO: `GridFilterPanel` lee SIEMPRE `option.label` y `option.value`, pero los
 * endpoints `/select` del backend no devuelven todos la misma forma. Al migrar el panel se asumió
 * que sí, y los dos que no siguen la convención quedaron con `label: undefined`. MUI v4 llama a
 * `getOptionLabel(...)` y le pide `.toLowerCase()` al filtrar, así que un label `undefined` no
 * muestra un desplegable vacío: **revienta el render y deja la pantalla en blanco** con sólo abrir
 * el filtro.
 *
 * Las dos excepciones, verificadas contra el panel viejo (que hacía `getOptionLabel` a mano):
 *
 *   /transportadoras/select -> { id, nombre }
 *   /rentadoras/select      -> { id, descripcion }
 *
 * Los otros 18 sí devuelven `{ value, label }`.
 *
 * Son las MISMAS dos que además serializaban `.id` en vez de `.value` (ver movilesFilterFields.js).
 * Al migrar cubrí el lado del valor y no el de la etiqueta.
 */

/** La propiedad que trae el texto, por endpoint que no usa `label`. */
export const CLAVE_ETIQUETA = {
	transportadora: 'nombre',
	rentadora: 'descripcion',
};

/**
 * Una lista del backend a opciones del panel.
 *
 * @param lista           lo que devolvió el endpoint
 * @param claveEtiqueta   de dónde sacar el texto, si no es `label`
 *
 * El `label` NUNCA queda undefined: es lo único que separa "el desplegable se ve vacío" de "la
 * pantalla se pone en blanco". Si ninguna de las claves conocidas está, se cae a string vacío.
 */
export const aOpciones = (lista, claveEtiqueta) =>
	(lista || []).map((item) => {
		const crudo = item || {};
		const etiqueta = claveEtiqueta && crudo[claveEtiqueta] !== undefined
			? crudo[claveEtiqueta]
			: (crudo.label !== undefined ? crudo.label : (crudo.nombre !== undefined ? crudo.nombre : crudo.descripcion));

		return {
			value: crudo.value !== undefined ? crudo.value : crudo.id,
			label: etiqueta === undefined || etiqueta === null ? '' : String(etiqueta),
		};
	});

/** Una lista separada por comas de config-business a opciones `{value, label}`. */
export const aOpcionesDeConfig = (texto) =>
	(texto ? texto.split(',') : []).map((valor) => ({ value: valor, label: valor }));
